module.exports = __webpack_public_path__ + "d53b3ecf056ae78235982d4f2a1e3c75.svg";